@let t = text();

<div class="hd-advanced-properties">
  <!-- Properties -->
  <section class="hd-advanced-properties__section">
    <h4 class="hd-advanced-properties__section-title">{{ t.propertiesTitle }}</h4>

    @if (compositePersons(); as persons) {
      <!-- Algemene relatieboek-info (introductie, connectiegrafiek, geest & gedachten). -->
      <div class="hd-advanced-properties__row">
        <button type="button" class="hd-advanced-properties__general-info"
                (click)="requestRelationInfo('general', $event)">
          <i class="fas fa-circle-info" aria-hidden="true"></i>
          {{ t.generalInfo }}
        </button>
      </div>
      <!-- Composite: geboortegegevens + natal-link (naam — type · profiel) per persoon. -->
      @for (person of persons; track person.chartId) {
        @if (person.birth; as birth) {
          <div class="hd-advanced-properties__row hd-advanced-properties__row--birth"
               [attr.title]="birthDataVisible() ? birth.tooltip : null">
            <span class="hd-advanced-properties__label">{{ birth.label }} — {{ person.name }}</span>
            <span class="hd-advanced-properties__value">
              @if (birthDataVisible()) {
                {{ birth.text }}
                @if (birth.age !== null) {
                  <hd-age-suffix [years]="birth.age" />
                }
                <button type="button" class="hd-advanced-properties__birth-reveal"
                        [attr.aria-label]="birth.hideLabel"
                        (click)="birthDataVisible.set(false)">
                  <i class="fas fa-eye-slash" aria-hidden="true"></i>
                </button>
              } @else {
                <span class="hd-advanced-properties__birth-hidden" aria-hidden="true">••••••••</span>
                <button type="button" class="hd-advanced-properties__birth-reveal"
                        [attr.aria-label]="birth.showLabel"
                        (click)="birthDataVisible.set(true)">
                  <i class="fas fa-eye" aria-hidden="true"></i>
                </button>
              }
            </span>
          </div>
          <!-- Design-tijdstip: maskeerbaar deel, verschijnt pas mét de geboortegegevens. -->
          @if (birthDataVisible() && birth.design; as design) {
            <div class="hd-advanced-properties__row hd-advanced-properties__row--design" [attr.title]="design.tooltip">
              <span class="hd-advanced-properties__label">{{ design.label }} — {{ person.name }}</span>
              <span class="hd-advanced-properties__value">{{ design.text }}</span>
            </div>
          }
        }
        <div class="hd-advanced-properties__row">
          <span class="hd-advanced-properties__label">{{ person.natalLabel }}</span>
          <button type="button" class="hd-advanced-properties__row-action" (click)="openCompositePerson(person.chartId)">
            {{ person.natalText }}
          </button>
        </div>
      }
      <!-- Boek-eigenschappen: type, profiel en beide kruisen per persoon (persoon-kleuren). -->
      @for (row of compositeInfoRows(); track row.label) {
        <div class="hd-advanced-properties__row">
          <span class="hd-advanced-properties__label">{{ row.label }}</span>
          <span class="hd-advanced-properties__value">
            <span class="hd-advanced-properties__person-values"
                  [class.hd-advanced-properties__person-values--stacked]="row.layout === 'stacked'">
              @for (value of row.values; track $index; let last = $last) {
                <span class="hd-advanced-properties__person-value"
                      [style.color]="value.color">{{ value.text }}</span>
                @if (row.layout === 'inline' && !last) {
                  <span class="hd-advanced-properties__person-separator" aria-hidden="true">·</span>
                }
              }
            </span>
            <button type="button" class="hd-advanced-properties__row-info"
                    [attr.aria-label]="row.infoLabel" [title]="row.infoLabel"
                    (click)="requestRelationInfo(row.topic, $event)">
              <i class="fas fa-circle-info" aria-hidden="true"></i>
            </button>
          </span>
        </div>
      }
      @if (compositeDefinition(); as definition) {
        <div class="hd-advanced-properties__row">
          <span class="hd-advanced-properties__label">{{ definition.label }}</span>
          <span class="hd-advanced-properties__value">{{ definition.text }}</span>
        </div>
      }
      <!-- Primaire conditionering van de combinatie: open centers (single/triple)
           of brugpoorten tussen de definitie-eilanden (split/quadruple). -->
      @if (compositeConditioning(); as conditioning) {
        <div class="hd-advanced-properties__row">
          <span class="hd-advanced-properties__label">{{ conditioning.label }}</span>
          <span class="hd-advanced-properties__value">
            <hd-primary-conditioning-value [vm]="conditioning"
              (centerHover)="$event ? onConditioningCenterEnter($event) : onConditioningCenterLeave()"
              (bridgeGateHover)="$event != null ? onBridgeGateEnter($event) : onBridgeGateLeave()"
              (bridgeGateClicked)="onBridgeGateClick($event.gate, $event.event)" />
            <button type="button" class="hd-advanced-properties__row-info"
                    [attr.aria-label]="conditioning.infoTooltip" [title]="conditioning.infoTooltip"
                    (click)="onConditioningInfoClick($event)">
              <i class="fas fa-circle-info" aria-hidden="true"></i>
            </button>
          </span>
        </div>
      }
      @if (compositeTheme(); as theme) {
        <div class="hd-advanced-properties__row">
          <span class="hd-advanced-properties__label">{{ theme.label }}</span>
          <span class="hd-advanced-properties__value">
            {{ theme.text }}
            <button type="button" class="hd-advanced-properties__theme-info"
                    [attr.aria-label]="theme.infoLabel" [title]="theme.infoLabel"
                    (click)="requestCompositeThemeInfo($event)">
              <i class="fas fa-circle-info" aria-hidden="true"></i>
            </button>
          </span>
        </div>
      }
    } @else {
      <!-- Gast (spec 2026-10-20-chart-share): geen geboortegegevens; de server stript ze al. -->
      @if (viewMode() !== 'guest') {
      @if (birth(); as birth) {
        <div class="hd-advanced-properties__row hd-advanced-properties__row--birth"
             [attr.title]="birthDataVisible() ? birth.tooltip : null">
          <span class="hd-advanced-properties__label">{{ birth.label }}</span>
          <span class="hd-advanced-properties__value">
            @if (birthDataVisible()) {
              {{ birth.text }}
              @if (birth.age !== null) {
                <hd-age-suffix [years]="birth.age" />
              }
              <button type="button" class="hd-advanced-properties__birth-reveal"
                      [attr.aria-label]="birth.hideLabel"
                      (click)="birthDataVisible.set(false)">
                <i class="fas fa-eye-slash" aria-hidden="true"></i>
              </button>
            } @else {
              <span class="hd-advanced-properties__birth-hidden" aria-hidden="true">••••••••</span>
              <button type="button" class="hd-advanced-properties__birth-reveal"
                      [attr.aria-label]="birth.showLabel"
                      (click)="birthDataVisible.set(true)">
                <i class="fas fa-eye" aria-hidden="true"></i>
              </button>
            }
            @if (showBirthWindowIndicator()) {
              <!-- Betrouwbaarheid van de geboortetijd (geboortevenster, spec 2026-10-16 §3.1). -->
              <hd-birth-window-indicator class="hd-advanced-properties__birth-window"
                                         [preset]="preset()"
                                         [moment]="birthWindowMoment()"
                                         (openRequested)="birthWindowRequested.emit()" />
            }
          </span>
        </div>
        <!-- Design-tijdstip: maskeerbaar deel, verschijnt pas mét de geboortegegevens. -->
        @if (birthDataVisible() && birth.design; as design) {
          <div class="hd-advanced-properties__row hd-advanced-properties__row--design" [attr.title]="design.tooltip">
            <span class="hd-advanced-properties__label">{{ design.label }}</span>
            <span class="hd-advanced-properties__value">{{ design.text }}</span>
          </div>
        }
      } @else {
        <div class="hd-advanced-properties__empty">{{ t.noBirthData }}</div>
      }
      }

      @if (natalLink(); as natal) {
        <div class="hd-advanced-properties__row">
          <span class="hd-advanced-properties__label">{{ natal.label }}</span>
          <button type="button" class="hd-advanced-properties__row-action" (click)="openNatal()">
            {{ natal.text }}
          </button>
        </div>
      }

      @if (cycleMoment(); as cycleMomentVm) {
        <div class="hd-advanced-properties__row" [attr.title]="cycleMomentVm.tooltip">
          <span class="hd-advanced-properties__label">{{ cycleMomentVm.label }}</span>
          <span class="hd-advanced-properties__value">
            {{ cycleMomentVm.text }}
            <!-- Leeftijd van de natal-persoon op het cyclusmoment. -->
            @if (cycleMomentVm.age !== null) {
              <hd-age-suffix [years]="cycleMomentVm.age" data-test-id="cycle-moment-age" />
            }
            @if (cycleMomentVm.endText; as endText) {
              <span class="hd-advanced-properties__cycle-end">· {{ endText }}</span>
            }
          </span>
        </div>
        <!-- Design-tijdstip van het cyclemoment: net als de rij erboven onverborgen. -->
        @if (cycleMomentVm.design; as design) {
          <div class="hd-advanced-properties__row hd-advanced-properties__row--design" [attr.title]="design.tooltip">
            <span class="hd-advanced-properties__label">{{ design.label }}</span>
            <span class="hd-advanced-properties__value">{{ design.text }}</span>
          </div>
        }
      }

      <!-- Snapshot-chart: het bewaarde moment + de bronchart (spec notable moments §4.3). -->
      @if (transitMomentInfo(); as transitVm) {
        <div class="hd-advanced-properties__row">
          <span class="hd-advanced-properties__label">{{ transitVm.momentLabel }}</span>
          <span class="hd-advanced-properties__value">
            {{ transitVm.momentText }}
            @if (momentBirthWindow(); as momentWindow) {
              <!-- Momentvenster: het tijdstip van het moment verschuiven, de natal chart blijft vast. -->
              <hd-birth-window-indicator class="hd-advanced-properties__birth-window"
                                         [preset]="momentWindow.preset"
                                         [overlay]="momentWindow.overlay"
                                         [moment]="true"
                                         (openRequested)="birthWindowRequested.emit()" />
            }
          </span>
        </div>
        <div class="hd-advanced-properties__row">
          <span class="hd-advanced-properties__label">{{ transitVm.natalLabel }}</span>
          <button type="button" class="hd-advanced-properties__row-action" (click)="openTransitSource()">
            {{ transitVm.natalText }}
          </button>
        </div>
      }
    }

    <!-- Classic I Ching (HexWave-ronde): enkel doorklikiconen, alle detail in het paneel. -->
    @if (ichingIconsVisible()) {
      @if (ichingBirthTarget()) {
        <div class="hd-advanced-properties__row" data-test-id="advanced-iching-birth">
          <span class="hd-advanced-properties__label">{{ t.ichingYourHexagram }}</span>
          <button type="button" class="hd-advanced-properties__row-action hd-advanced-properties__iching"
                  [title]="t.ichingOpen" [attr.aria-label]="t.ichingOpen" (click)="openIChingBirth($event)">
            <i class="fa-regular fa-scroll-old" aria-hidden="true"></i>
          </button>
        </div>
      }
      @if (ichingPairTarget()) {
        <div class="hd-advanced-properties__row" data-test-id="advanced-iching-pair">
          <span class="hd-advanced-properties__label">{{ t.ichingPair }}</span>
          <button type="button" class="hd-advanced-properties__row-action hd-advanced-properties__iching"
                  [title]="t.ichingOpen" [attr.aria-label]="t.ichingOpen" (click)="openIChingPair($event)">
            <i class="fa-regular fa-scroll-old" aria-hidden="true"></i>
          </button>
        </div>
      }
    }
  </section>

  <!-- Locks & Keys slot-sleutelrelatie (alleen composite): wie wiens sleutel
       invult, voor de nú geldende periode; knop opent de volledige L&K-modus. -->
  @if (locksKeysRelationship(); as rel) {
    <section class="hd-advanced-properties__section hd-advanced-properties__locks-keys">
      <h4 class="hd-advanced-properties__section-title hd-advanced-properties__section-title--with-action">
        <span>{{ rel.title }}</span>
        <!-- Dubbele (segmented) toggle: de gemarkeerde knop is de getoonde era. -->
        <e-segmented-toggle
          class="hd-advanced-properties__locks-keys-period"
          size="xs"
          testId="advanced-locks-keys-period"
          [groupLabel]="rel.periodLabel"
          [options]="rel.periodOptions"
          [value]="relationshipPeriod()"
          (valueChange)="setRelationshipPeriod($event)"
        ></e-segmented-toggle>
      </h4>
      <p class="hd-advanced-properties__locks-keys-hint">{{ rel.hint }}</p>
      @if (rel.rows.length > 0) {
        @for (row of rel.rows; track row.id) {
          <div class="hd-advanced-properties__locks-keys-row">
            <span class="hd-advanced-properties__locks-keys-party">
              <span class="hd-advanced-properties__locks-keys-lead">
                <span class="hd-advanced-properties__person-value" [style.color]="row.left.color">{{ row.left.name }}</span>
                @for (holding of row.left.holdings; track holding.kind) {
                  <span class="hd-advanced-properties__locks-keys-flag" [attr.data-kind]="holding.kind">
                    <i class="fas" [class.fa-key]="holding.kind === 'key'" [class.fa-lock]="holding.kind === 'lock'" aria-hidden="true"></i>{{ holding.gateText }}
                  </span>
                }
              </span>
              @for (holding of row.left.holdings; track holding.kind) {
                @if (holding.keynote) {
                  <span class="hd-advanced-properties__locks-keys-keynote">{{ holding.keynote }}</span>
                }
              }
            </span>
            <i class="fas hd-advanced-properties__locks-keys-arrow"
               [class.fa-arrow-right]="row.direction === 'forward'"
               [class.fa-arrow-right-arrow-left]="row.direction === 'both'"
               aria-hidden="true"></i>
            <span class="hd-advanced-properties__locks-keys-party">
              <span class="hd-advanced-properties__locks-keys-lead">
                <span class="hd-advanced-properties__person-value" [style.color]="row.right.color">{{ row.right.name }}</span>
                @for (holding of row.right.holdings; track holding.kind) {
                  <span class="hd-advanced-properties__locks-keys-flag" [attr.data-kind]="holding.kind">
                    <i class="fas" [class.fa-key]="holding.kind === 'key'" [class.fa-lock]="holding.kind === 'lock'" aria-hidden="true"></i>{{ holding.gateText }}
                  </span>
                }
              </span>
              @for (holding of row.right.holdings; track holding.kind) {
                @if (holding.keynote) {
                  <span class="hd-advanced-properties__locks-keys-keynote">{{ holding.keynote }}</span>
                }
              }
            </span>
          </div>
        }
      } @else {
        <p class="hd-advanced-properties__empty">{{ rel.none }}</p>
      }
      <button type="button" class="hd-advanced-properties__locks-keys-more" (click)="requestLocksKeys()">
        <i class="fas fa-lock" aria-hidden="true"></i>
        {{ rel.moreInfo }}
      </button>
    </section>
  }

  <!-- Connectiviteitspoorten (alleen composite): de liefdespoorten die minstens
       één van beide charts activeert, met de basic love-keynote; klik opent het
       love-gates-paneel gescrolld naar die poort. -->
  @if (loveConnectivity(); as love) {
    <section class="hd-advanced-properties__section hd-advanced-properties__love">
      <h4 class="hd-advanced-properties__section-title">{{ love.title }}</h4>
      @if (love.rows.length > 0) {
        @for (row of love.rows; track row.gate) {
          <button
            type="button"
            class="hd-advanced-properties__love-row"
            [title]="love.hint"
            (click)="openLoveGate(row.gate, $event)">
            <i class="fa-regular fa-circle-heart hd-advanced-properties__love-icon" aria-hidden="true"></i>
            <span class="hd-advanced-properties__love-gate">{{ row.gate }}</span>
            <span class="hd-advanced-properties__love-keynote">{{ row.keynote }}</span>
            <span class="hd-advanced-properties__love-persons">
              @for (person of row.persons; track $index) {
                <span class="hd-advanced-properties__person-value" [style.color]="person.color">{{ person.name }}</span>
              }
            </span>
          </button>
        }
      } @else {
        <p class="hd-advanced-properties__empty">{{ love.none }}</p>
      }
    </section>
  }

  <!-- Cycles (spec cycle charts §9): eigen sectie, gedeeld relatie-mechanisme;
       bewust boven Relaties. Op een composite chart niet van toepassing. -->
  @if (!isCompositeChart()) {
    <hd-cycles-section
      [savedChartId]="savedChartId()"
      [chartType]="chartType()"
      [preset]="preset()"
      [chartName]="chartName()"
      [relations]="relations()"
      [matchScope]="matchScope()"
      [viewMode]="viewMode()"
      (accountRequired)="accountRequired.emit()"
      (calculateRequested)="cycleCalculateRequested.emit($event)"
      (justNowTransitRequested)="cycleJustNowTransitRequested.emit()"
      (chartOpenRequested)="chartOpenRequested.emit($event)"
      (recalculateRequested)="cycleRecalculateRequested.emit()"
      (lifeCrossInfoRequested)="cycleLifeCrossInfoRequested.emit($event)"
      (chironInfoRequested)="cycleChironInfoRequested.emit($event)"
      (definitionInfoRequested)="cycleDefinitionInfoRequested.emit($event)"
      (gateInfoRequested)="gateInfoRequested.emit($event)"
    ></hd-cycles-section>
  }

  <!-- Momenten (spec notable moments §4.4): het groeiende archief van bewaarde
       momenten — sibling van de Cycles-sectie, bewust boven Relaties, op álle
       opgeslagen charttabs (beslispunt 10). -->
  <hd-moments-section
    [savedChartId]="savedChartId()"
    [chartName]="chartName()"
    [preset]="preset()"
    [relations]="relations()"
    [loading]="relationsLoading()"
    [error]="relationsError()"
    [viewMode]="viewMode()"
    (chartOpenRequested)="chartOpenRequested.emit($event)"
    (chartOpenWithNotesRequested)="chartOpenWithNotesRequested.emit($event)"
    (timelineRequested)="timelineRequested.emit($event)"
    (mindLogRequested)="mindLogRequested.emit($event)"
  ></hd-moments-section>

  <!-- Cyclus-keynotes (alleen op een cycle chart): Persoonlijk / Educatief / Omgevend. -->
  <hd-cycle-keynote-sections
    [preset]="preset()"
    (gateInfoRequested)="gateInfoRequested.emit($event)"
    (channelInfoRequested)="channelInfoRequested.emit($event)"
    (centerInfoRequested)="centerInfoRequested.emit($event)"
  />

  <!-- Relatie / Composiet details (alleen op een composite chart). -->
  <hd-composite-sections
    [preset]="preset()"
    (gateInfoRequested)="gateInfoRequested.emit($event)"
    (channelInfoRequested)="channelInfoRequested.emit($event)"
    (relationInfoRequested)="relationInfoRequested.emit($event)"
    (centerInfoRequested)="centerInfoRequested.emit($event)"
  />

  <!-- Relations (systeem-koppelingen van cycle/composite charts blijven buiten deze lijst) -->
  @if (!isCycleChart() && !isCompositeChart()) {
  <section class="hd-advanced-properties__section">
    <h4 class="hd-advanced-properties__section-title hd-advanced-properties__section-title--with-action">
      <span>{{ t.relationsTitle }}</span>
      <span class="hd-advanced-properties__section-action-group">
        @if (savedChartId() && viewMode() === 'owner') {
          <button type="button" class="hd-advanced-properties__section-action"
                  [attr.aria-label]="t.addRelation" [title]="t.addRelation"
                  (click)="openRelationsDialog()">
            <i class="fas fa-plus" aria-hidden="true"></i>
          </button>
        }
        <!-- Open-/dichtklappen helemaal rechts; standaard dichtgeklapt. -->
        <button type="button" class="hd-advanced-properties__section-action"
                [attr.aria-expanded]="relationsExpanded()"
                [attr.aria-label]="relationsExpanded() ? t.hideRelations : t.showRelations"
                [title]="relationsExpanded() ? t.hideRelations : t.showRelations"
                (click)="toggleRelationsExpanded()">
          <i class="fas fa-chevron-right hd-advanced-properties__section-chevron"
             [class.hd-advanced-properties__section-chevron--open]="relationsExpanded()"
             aria-hidden="true"></i>
        </button>
      </span>
    </h4>

    @if (relationsExpanded()) {
      @if (viewMode() !== 'owner') {
        <!-- Gedeelde chart (spec 2026-10-20-chart-share §4.5): geen relaties, ook niet ingelogd. -->
        <div class="hd-advanced-properties__empty" data-test-id="relations-shared-unavailable">{{ t.sharedUnavailable }}</div>
      } @else if (!savedChartId()) {
        <div class="hd-advanced-properties__empty">{{ t.saveFirst }}</div>
      } @else if (relationsLoading()) {
        <div class="hd-advanced-properties__empty">{{ t.loading }}</div>
      } @else if (relationsError()) {
        <div class="hd-advanced-properties__error">{{ relationsError() }}</div>
      } @else if (humanRelations().length === 0) {
        <div class="hd-advanced-properties__empty">{{ t.noRelations }}</div>
      } @else {
        @for (row of relationRows(); track row.relation.id) {
          @let relation = row.relation;
          <div class="hd-advanced-properties__relation-row">
            <button type="button" class="hd-advanced-properties__relation"
                    [disabled]="!relation.otherChartId"
                    (click)="openRelation(relation)">
              <i [class]="'fas fa-' + relationIcon(relation.relationType) + ' hd-advanced-properties__relation-icon'"
                 aria-hidden="true"></i>
              <span class="hd-advanced-properties__relation-type">{{ relationLabel(relation.relationType) }}</span>
              <span class="hd-advanced-properties__relation-name">{{ relation.otherChartName }}</span>
              <!-- Overige relatietypen van dezelfde persoon (tooltip = het label). -->
              @for (extraType of row.extraTypes; track extraType) {
                <i [class]="'fas fa-' + relationIcon(extraType) + ' hd-advanced-properties__relation-extra-type'"
                   [title]="relationLabel(extraType)"></i>
              }
              @if (relationMeta(relation)) {
                <span class="hd-advanced-properties__relation-meta">{{ relationMeta(relation) }}</span>
              }
            </button>
            @if (compositeActionFor(relation); as action) {
              <!-- Composiet met deze persoon: berekenen, of openen als hij al bestaat. -->
              <button type="button" class="hd-advanced-properties__relation-composite"
                      [title]="action.kind === 'open' ? t.compositeOpenTooltip : t.compositeCalculateTooltip"
                      (click)="onCompositeAction(relation)">
                {{ action.kind === 'open' ? t.compositeOpen : t.compositeCalculate }}
              </button>
            }
          </div>
        }
      }
    }
  </section>
  }

  <!-- Fixed star (66 Sides): dichtstbijzijnde ster bij de design-noordknoop
       + extra sterren binnen 2° van elke planeetactivatie. Enkel op
       standaardcharts: niet op composites (de ster leidt enkel uit chart 1's
       design-noordknoop af) en niet op cyclus-/momentcharts (die dragen de
       natal-snapshot, dus de sterren van de bronchart). -->
  @if (showFixedStars() && fixedStarsVm(); as fs) {
    <section class="hd-advanced-properties__section">
      <h4 class="hd-advanced-properties__section-title hd-advanced-properties__section-title--with-info">
        {{ fs.title }}
        <button type="button" class="hd-advanced-properties__fixed-star-info"
                [attr.aria-label]="fs.generalInfoTooltip"
                [title]="fs.generalInfoTooltip"
                (click)="openFixedStarGeneralInfo($event)">
          <i class="fas fa-circle-info" aria-hidden="true"></i>
        </button>
      </h4>

      @if (viewMode() === 'guest') {
        <!-- Gast: geen geboortemoment (server-side gestript), dus geen precessie-correctie mogelijk. -->
        <p class="hd-advanced-properties__fixed-star-note" data-test-id="fixed-stars-guest-unavailable">{{ t.guestUnavailable }}</p>
      } @else if (!fs.available || fs.primary === null) {
        <p class="hd-advanced-properties__fixed-star-note">{{ fs.unknown }}</p>
      } @else {
        <div class="hd-advanced-properties__row">
          <span class="hd-advanced-properties__label">
            <span class="hd-advanced-properties__fixed-star-glyph" aria-hidden="true">{{ fs.primary.planetGlyph }}</span>
            {{ fs.primary.label }}
          </span>
          <span class="hd-advanced-properties__value hd-advanced-properties__fixed-star-value">
            <span class="hd-advanced-properties__fixed-star-name">{{ fs.primary.name }}</span>
            <span class="hd-advanced-properties__fixed-star-distance">({{ fs.primary.distance }})</span>
            <button type="button" class="hd-advanced-properties__fixed-star-info"
                    [attr.aria-label]="fs.infoTooltip"
                    [title]="fs.infoTooltip"
                    (click)="openFixedStarInfo(fs.primary, $event)">
              <i class="fas fa-circle-info" aria-hidden="true"></i>
            </button>
          </span>
        </div>

        <!-- Extra fixed stars op aanvraag: standaard dicht en pas open berekend. -->
        <button type="button" class="hd-advanced-properties__fixed-star-extras-toggle"
                [attr.aria-expanded]="fixedStarExtrasVisible()"
                (click)="toggleFixedStarExtras()">
          <i class="fas fa-chevron-right hd-advanced-properties__section-chevron"
             [class.hd-advanced-properties__section-chevron--open]="fixedStarExtrasVisible()"
             aria-hidden="true"></i>
          {{ fs.extrasToggle }}
        </button>
        @if (fixedStarExtrasVisible()) {
          <div class="hd-advanced-properties__fixed-star-extras-title">
            <span>{{ fs.extrasTitle }}</span>
            <button type="button" class="hd-advanced-properties__fixed-star-info"
                    [attr.aria-label]="fs.extrasInfoTooltip"
                    [title]="fs.extrasInfoTooltip"
                    (click)="openFixedStarExtrasInfo($event)">
              <i class="fas fa-circle-info" aria-hidden="true"></i>
            </button>
          </div>
          @if (fs.extras.length === 0) {
            <p class="hd-advanced-properties__fixed-star-note">{{ fs.extrasEmpty }}</p>
          } @else {
            @for (extra of fs.extras; track extra.side + '-' + extra.label) {
              <div class="hd-advanced-properties__row">
                <span class="hd-advanced-properties__label">
                  <span class="hd-advanced-properties__fixed-star-glyph" aria-hidden="true">{{ extra.planetGlyph }}</span>
                  {{ extra.label }}
                </span>
                <span class="hd-advanced-properties__value hd-advanced-properties__fixed-star-value">
                  <span class="hd-advanced-properties__fixed-star-name">{{ extra.name }}</span>
                  <span class="hd-advanced-properties__fixed-star-distance">({{ extra.distance }})</span>
                  <button type="button" class="hd-advanced-properties__fixed-star-info"
                          [attr.aria-label]="fs.infoTooltip"
                          [title]="fs.infoTooltip"
                          (click)="openFixedStarInfo(extra, $event)">
                    <i class="fas fa-circle-info" aria-hidden="true"></i>
                  </button>
                </span>
              </div>
            }
          }
        }
      }
    </section>
  }

  <!-- Locks & Keys-basisinfo (spec 2026-10-10): de locks/keys van deze chart
       zonder de modus te activeren, de chart-overlay-toggle en een knop naar de
       volledige modus (= de shortcut-knop). -->
  <hd-locks-keys-chart-summary (modeRequested)="requestLocksKeys()" />
</div>

<!-- Geen (changed)-binding nodig: mutaties lopen via de chart-services en de datacache volgt. -->
<hd-chart-relations-dialog
  [(target)]="relationsDialogTarget"
></hd-chart-relations-dialog>
